import PartnersPanel from './PartnersPanel';

export default PartnersPanel;
